<template>
  <div class="promo-code-section">
    <div class="promo-code-header">
      <span class="promo-code-title">{{ $t('Bao.payment_promo_code_1') }}</span>
      <a class="promo-code-link" @click.prevent="$emit('open-coupon')">{{ $t('Bao.payment_promo_code_view') }}</a>
    </div>
    <!-- 可報名優惠托盤：task-code 清單為空、但有報名紀錄時只藏托盤（連同注意文案），保留標題＋查看優惠碼 -->
    <div v-if="cards.length > 0" class="promo-avail">
      <div class="promo-avail-title">
        <i class="fa-solid fa-gift" aria-hidden="true" />
        {{ $t('Bao.payment_promo_code_available') }}
        <span v-if="availableCount > 0" class="promo-avail-count">{{ availableCount }}</span>
      </div>
      <div ref="list" class="promo-avail-list" @scroll="updateArrows">
        <div
          v-for="card in cards"
          :key="card.id"
          class="promo-avail-card"
          :class="{ 'promo-avail-done': card.done, 'promo-avail-ineligible': card.ineligible }"
        >
          <div class="promo-avail-info">
            <!--eslint-disable-next-line -->
            <span v-if="card.name" class="promo-avail-name" v-html="card.name" />
            <p v-if="card.ineligible" class="promo-avail-reason">
              {{ $t('Bao.payment_promo_code_first_deposit_done') }}
            </p>
            <template v-else>
              <p class="promo-avail-code">
                {{ $t('Bao.payment_promo_code_2') }}：<span>{{ card.code }}</span>
              </p>
              <p class="promo-avail-expire">
                {{ $t('Bao.payment_promo_code_expiry') }}：{{ card.endAt | dateFormat }}
              </p>
            </template>
          </div>
          <button
            type="button"
            class="promo-avail-use"
            :disabled="card.done || card.ineligible"
            @click="$emit('register', card)"
          >
            {{ buttonText(card) }}
          </button>
        </div>
      </div>
      <!-- PC 橫滑箭頭：可捲動才顯示，捲到頭 disable（手機由 CSS 隱藏，直接手滑） -->
      <button
        v-show="canScroll"
        type="button"
        class="promo-avail-arr promo-avail-arr-prev"
        :disabled="atStart"
        @click="scrollStep(-1)"
      >
        &#10094;
      </button>
      <button
        v-show="canScroll"
        type="button"
        class="promo-avail-arr promo-avail-arr-next"
        :disabled="atEnd"
        @click="scrollStep(1)"
      >
        &#10095;
      </button>
    </div>
    <p v-if="cards.length > 0" class="promo-code-notice">
      {{ $t('Bao.payment_promo_code_notice') }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'PromoCode',
  props: {
    cards: {
      type: Array,
      default: () => []
    },
    availableCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      canScroll: false,
      atStart: true,
      atEnd: true
    }
  },
  watch: {
    cards() {
      this.$nextTick(this.observeList)
    }
  },
  mounted() {
    this.observeList()
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect()
  },
  methods: {
    buttonText(card) {
      if (card.ineligible) return this.$t('Bao.payment_promo_code_ineligible')
      if (card.done) return this.$t('Bao.payment_promo_code_registered_1')
      return this.$t('Bao.payment_promo_code_sign')
    },
    // 托盤在手機／PC 容器切換顯示時尺寸會變，用 ResizeObserver 重新判斷是否可捲動
    observeList() {
      const list = this.$refs.list
      if (list && list !== this.observedList) {
        if (!this.resizeObserver) {
          this.resizeObserver = new ResizeObserver(() => this.updateArrows())
        }
        this.resizeObserver.disconnect()
        this.resizeObserver.observe(list)
        this.observedList = list
      }
      this.updateArrows()
    },
    updateArrows() {
      const list = this.$refs.list
      if (!list) return
      this.canScroll = list.scrollWidth > list.clientWidth + 1
      this.atStart = list.scrollLeft <= 0
      this.atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1
    },
    scrollStep(direction) {
      const list = this.$refs.list
      const card = list && list.querySelector('.promo-avail-card')
      if (!card) return
      list.scrollBy({ left: direction * (card.offsetWidth + 8), behavior: 'smooth' })
    }
  }
}
</script>
